import { createSafeContext } from '@/package';

import type { TaskListContextValue } from './type';

export const TaskListContext = createSafeContext<TaskListContextValue>(
  {} as TaskListContextValue,
  'TaskListContext',
);
